import React from 'react';

const NotFoundPage = () => {
    let themeMode = window.localStorage.getItem("mode")
    const mode = themeMode || 'night'

    return (
        <div className={`flex flex-col items-center justify-center h-screen ${mode ==='night'?"bg-gray-900":"bg-gray-100"}`}>
            <h2 className={`text-4xl font-bold mb-4 ${mode === 'night' ? "text-gray-300" : "text-gray-700"} `}>404 Not Found</h2>
            <p className={`${mode === 'night' ? "text-gray-400" : "text-gray-600"}`}>Sorry, the page you are looking for does not exist.</p>
        </div>
    );
};

export default NotFoundPage;
